import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { Utils } from '@app/_core/helper/Utils';
import { coerceStringArray } from '@angular/cdk/coercion';
import * as moment from 'moment-timezone';
@Pipe({ name: 'getkey' })
export class GetKeyPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }
    transform(obj: string) {
        return Object.keys(obj);
    }
}

@Pipe({ name: 'custdate' })
export class CustDatePipe implements PipeTransform {
    browserLanguage: string = navigator.language;
    Usertimezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
    constructor(
        private sanitizer: DomSanitizer,
        private utils: Utils
    ) { }
    transform(obj: string) {
        let res = obj;
        if (obj && obj != null && obj != undefined && obj != '-') {
            res = this.utils.GetESTtoLocalTimeZone(obj);
        }
        return res;
    }
}

@Pipe({ name: 'custdateonly' })
export class CustDateOnlyPipe implements PipeTransform {
    browserLanguage: string = navigator.language;
    Usertimezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
    constructor(
        private sanitizer: DomSanitizer,
        private utils: Utils
    ) { }
    transform(obj: string) {
        let res = null;
        if (obj != null) {
            let contDate = this.utils.GetESTtoLocalTimeZone(obj);
            res = this.utils.formatDate(contDate);
        }
        return res;
    }
}

@Pipe({ name: 'custdatenotimeconversion' })
export class CustDateNoTimeConversionPipe implements PipeTransform {

  constructor(private utils: Utils) {}

  transform(obj: string): string | null {
    if (!obj || obj === '-' || obj.trim() === '') {
      return '';
    }

    let datePart = obj;
    return this.utils.formatDate(datePart);
  }
}

@Pipe({ name: 'formatTimeForScreen' })
export class formatTimeForScreen implements PipeTransform {
    constructor(
    ) { }
    transform(seconds: string) {
        return this.formatTime(seconds);
    }
    formatTime(seconds) {
        let hours = Math.floor(seconds / 3600);
        seconds %= 3600;
        let minutes = Math.floor(seconds / 60);
        let secs = Math.floor(seconds % 60);

        return [hours, minutes, secs]
            .map(v => v < 10 ? '0' + v : v)
            .filter((v, i) => v !== '00' || i > 0)
            .join(':');
    }
}


// @Pipe({ name: 'highlight' })
// export class HighlightPipe implements PipeTransform {
//     constructor(private sanitizer: DomSanitizer) { }

//     transform(text: string, searchTerms: string[]): any {
//         if (!text || !searchTerms || searchTerms.length === 0) {
//             return text;
//         }

//         let highlightedText = text;
//         searchTerms.forEach(term => {
//             const regex = new RegExp(term, 'gi');
//             highlightedText = highlightedText.replace(regex, (match) => `<mark>${match}</mark>`);
//         }); 
//         return this.sanitizer.bypassSecurityTrustHtml(highlightedText);
//     }
// }

// import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlight'
})
export class HighlightPipe implements PipeTransform {
    transform(value: string, searchTerms: string): any {
        if (!searchTerms || !value) return value;

        const keywords = searchTerms
            .split('|')
            .filter(term => term.trim().length > 0)
            .map(term => this.escapeRegExp(term));

        if (keywords.length === 0) return value;

        const regex = new RegExp(`(${keywords.join('|')})`, 'gi');
        return value.replace(regex, `<mark>$1</mark>`);
    }

    escapeRegExp(str: string) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape RegEx special chars
    }
}
